<template>
  <div class="common-box">
    <el-form
      inline
      ref="form"
      class="search-form common-box-search-form"
      label-position="right"
      :model="form"
      label-width="70px"
    >
      <search-form @search="handleSearch" @refresh="handleRefresh">
        <div slot="content">
          <el-form-item label="部门名称：">
            <el-input
              @change="handleSearchListData"
              size="mini"
              v-model.trim="form.departmentName"
              placeholder="请输入部门名称"
              clearable
            ></el-input>
          </el-form-item>
        </div>
      </search-form>
    </el-form>
    <div class="common-cover-div"></div>
    <div class="operation-and-table__container">
      <div class="btns__container">
        <el-button
          size="mini"
          type="primary"
          @click="exportDepartment"
          class="plr28"
          v-if="hasRole['BMGLDR']"
        >导入</el-button>
        <el-button
          size="mini"
          type="primary"
          @click="exportDepartment"
          plain
          class="plr28"
          v-if="hasRole['BMGLDC']"
        >导出</el-button>
        <el-button
          size="mini"
          type="primary"
          class="plr28"
          @click="handleDelete"
          plain
          v-if="hasRole['BMGLSC']"
        >删除</el-button>
      </div>
      <div class="table__container">
        <el-table
          v-loading="tableLoading"
          :data="treeList"
          max-height="400"
          border
          ref="multipleTable"
          row-key="id"
          style="width: 100%"
          :tree-props="{children: 'childrenList' }"
        >
          >
          <!-- <el-table-column show-overflow-tooltip prop="targetDate" label="月份" width="120"></el-table-column> -->
          <el-table-column
            show-overflow-tooltip
            prop="departmentName"
            fixed
            width="260"
            label="部门名称"
          ></el-table-column>
          <el-table-column prop="employeeNum" label="成员数" fixed width="120" show-overflow-tooltip></el-table-column>
          <el-table-column prop="partTimeNum" label="兼任人员" fixed show-overflow-tooltip></el-table-column>
          <!-- <el-table-column label=" "></el-table-column> -->
          <el-table-column label="操作" width="150px" fixed="right">
            <template slot-scope="scope">
              <el-button
                v-if="hasRole['BMGLTJ']"
                size="mini"
                type="text"
                class="plr28"
                @click="handleAdd(scope.row)"
              >添加</el-button>
              <div v-if="hasRole['BMGLTJ']" class="btn-divide"></div>
              <el-button
                size="mini"
                v-if="hasRole['BMGLBJ']"
                type="text"
                @click="editDepartment(scope.row)"
              >编辑</el-button>
              <div class="btn-divide" v-if="hasRole['BMGLBJ']"></div>
              <el-button
                type="text"
                v-if="hasRole['BMGLSC']"
                size="mini"
                @click="deleteDepartment(scope.row)"
              >删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagenation__container">
        <div class="for-fff-bg">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageIndex"
            :page-sizes="[25, 50, 100, 150, 200]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
        </div>
      </div>
    </div>
    <edit-department
      :unitId="departmentDetail.unitId"
      :editData="departmentDetail"
      v-if="showEditDepartment"
      @confirm="editDepartmentConfirm"
      @cancel="showEditDepartment=false"
    ></edit-department>
    <add-department
      v-if="addDepartmentVisible"
      :editData="departmentDetail"
      @confirm="handleAddDepartmentConfirm"
      @cancel="addDepartmentVisible=false"
    ></add-department>
  </div>
</template>

<script>
import {
  getDepartmentTree,
  deleteDepartment,
  exportDepartment,
} from "@/api/DepartmentManagement";
import EditDepartment from "./components/EditDepartment";
import AddDepartment from "./components/AddDepartment";
export default {
  name: "DepartmentManagement",
  components: {
    EditDepartment,
    AddDepartment,
  },
  data() {
    return {
      form: {
        departmentName: "",
      },
      tableLoading: false,
      list: [],
      multipleSelection: [],
      pageIndex: 1,
      pageSize: 50,
      total: 0,
      addDepartmentVisible: false,
      editDepartmentVisible: false,
      checkDepartmentVisible: false,
      checkDepartment: false,
      departmentDetail: {},
      treeList: [],
      showEditDepartment: false,
    };
  },
  computed: {
    hasRole: function () {
      return this.$store.getters["common/promise/getRole"](this.$route.path);
    },
  },
  created() {
    this.getListData();
  },
  methods: {
    async getListData() {
      this.tableLoading = true;
      const params = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      };
      for (let key in this.form) {
        if (this.form[key]) params[key] = this.form[key];
      }
      const res = await getDepartmentTree(params);
      if (res.code === 200) {
        this.treeList = res.data;
      }
      this.tableLoading = false;
    },
    handleSearch() {
      this.pageIndex = 1;
      this.getListData();
    },
    handleRefresh() {
      for (let key in this.form) {
        if (Array.isArray(this.form[key])) {
          this.form[key] = [];
        } else {
          this.form[key] = "";
        }
      }
      this.pageIndex = 1;
      this.getListData();
    },
    handleSearchListData() {
      this.pageIndex = 1;
      this.getListData();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleDeleteDepartment(row) {
      const idList = [row.id];
      this.deleteDepartment(idList);
    },
    handleCheck(row) {
      this.departmentDetail = row;
      this.checkDepartment = true;
    },
    handleEdit(row) {
      this.departmentDetail = row;
      this.editDepartmentVisible = true;
    },
    handleDelete() {
      if (!this.multipleSelection.length) {
        this.$message.warning("请选择要删除的行");
        return;
      }
      const idList = this.multipleSelection.map((item) => item.id);
      this.deleteDepartment(idList);
    },
    deleteDepartment(idList) {
      this.$confirm("确定删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const res = await deleteDepartment({ idList });
          if (res.code === 200) {
            this.$message.success("删除成功");
            this.getListData();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleAdd(row) {
      this.departmentDetail = row
      this.addDepartmentVisible = true;
    },
    exportDepartment() {
      const params = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      };
      for (let key in this.form) {
        if (this.form[key]) params[key] = this.form[key];
      }
      exportDepartment(params);
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getListData();
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getListData();
    },
    handleAddDepartmentConfirm() {
      this.addDepartmentVisible = false;
      this.pageIndex = 1;
      this.getListData();
    },
    handleEditDepartmentConfirm() {
      this.editDepartmentVisible = false;
      this.getListData();
    },
    editDepartment(row) {
      this.departmentDetail = row;
      this.showEditDepartment = true;
    },
    deleteDepartment(row) {
      const idList = [row.id];
      this.$confirm("确定删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const res = await deleteDepartment({ idList });
          if (res.code === 200) {
            this.$message.success("删除成功");
            this.getListData();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    editDepartmentConfirm() {
      this.showEditDepartment = false
      this.getListData()
    }
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/DepartmentManagement/DepartmentManagement.vue